export default {
  "Your order has been shipped": "Your order has been shipped",
  "Parcel #": "Parcel #{index}",
  "401": {
    "description": "You are not authorizes to show this page",
    "title": "Not authorised"
  },
  "404": {
    "description": "Discover our products and have fun!",
    "title": "Page not found"
  },
  " on ": " on ",
  "2 factors auth": "2 factors auth",
  "48H delivery": "48h delivery",
  "a problem with your order ?": "A problem with your order ?",
  "About us": "About us",
  "Account already exists": "Account already exists",
  "account": {
    "address": "Address book",
    "informations": "Profile",
    "logout": "Sign out",
    "modal": {
      "personal": {
        "title": {
          "html": "Personal<br/> account",
          "str": "Personal account"
        }
      }
    },
    "orders": "Orders",
    "wishlist": "My wishlist"
  },
  "accountForm": {
    "authToggle": "<strong>Activate dual authentification</strong> (For a better secure access to your account)",
    "birthDate": {
      "error": "birthdate error",
      "required": "birthdate required"
    },
    "email": {
      "error": "email seems incorrect",
      "required": "email is required"
    },
    "firstName": {
      "error": "firstname seems incorrect",
      "required": "firstname is required"
    },
    "lastName": {
      "error": "lastname seems incorrect",
      "required": "lastName is required"
    },
    "newPassword": {
      "error": "Invalid password. Please check the mandatory and/or authorised characters.",
      "required": "password is required"
    },
    "newsletterToggle": "<strong>Subscribe newsletter</strong> (Get our latest news and best plans)",
    "password": {
      "error": "Invalid password. Please check the mandatory and/or authorised characters.",
      "required": "password is required"
    },
    "repeatPassword": {
      "error": "passwords not match",
      "required": "please repeat you password"
    }
  },
  "Add a billing address": "Add a billing address",
  "Add new address": "Add new address",
  "Add the address": "Add the address",
  "Add to cart": "Add to cart",
  "addedProduct": "It's in the cart</br><span class='product'> {product} to your cart</span>",
  "Address details": "Address details",
  "Address label": "Address label",
  "Address name is required": "Address name is required",
  "Address Name": "Address Name",
  "address": {
    "billing": "default billing address updated",
    "created": "address created",
    "removed": "address removed",
    "shipping": "default shipping address updated",
    "updated": "address updated"
  },
  "addressForm": {
    "city": {
      "error": "city error",
      "required": "city required"
    },
    "country": {
      "error": "country error",
      "required": "country required"
    },
    "firstName": {
      "error": "firstname error",
      "required": "firstname required"
    },
    "lastName": {
      "error": "lastname error",
      "required": "lastname required"
    },
    "phone": {
      "error": "phone error",
      "required": "phone required"
    },
    "postCode": {
      "error": "postCode error",
      "required": "postCode required"
    },
    "street": {
      "error": "street error",
      "required": "street required"
    }
  },
  "addToCart": {
    "add": "Product added to cart",
    "max": "Max allowed quantity",
    "remove": "Product removed from cart",
    "update": "Product quantity updated"
  },
  "adyen": {
    "errorCode10": "The shopper's bank does not support or does not allow this type of transaction.\n",
    "errorCode11": "3D Secure authentication was not executed, or it did not execute successfully.\n",
    "errorCode12": "The card does not have enough money to cover the payable amount.\n",
    "errorCode14": "Possible fraud.\n",
    "errorCode15": "The transaction was cancelled.\n",
    "errorCode16": "The shopper cancelled the transaction before completing it.\n",
    "errorCode17": "The specified PIN is incorrect or invalid.\n",
    "errorCode18": "The shopper specified an incorrect PIN more that three times in a row.\n",
    "errorCode19": "It is not possible to validate the specified PIN number.\n",
    "errorCode2": "The transaction was refused.\n",
    "errorCode20": "The pre-authorisation risk checks resulted in a fraud score of 100 or more. Therefore, the transaction was flagged as fraudulent, and was refused.\n",
    "errorCode21": "The transaction was not submitted correctly for processing.\n",
    "errorCode22": "The sum of pre-authorisation and post-authorisation risk checks resulted in a fraud score of 100 or more. Therefore, the transaction was flagged as fraudulent, and was refused.\n",
    "errorCode23": "The following declined codes are mapped to this refusal reason:\n\"57: Transaction not permitted to issuer/cardholder\"\n\"57: Transaction not allowed for this merchant\"\n\"58: Transaction not permitted to acquirer/terminal\"\n",
    "errorCode24": "The specified CVC (card security code) is invalid.\n",
    "errorCode25": "The following decline codes are mapped to this refusal reason:\n\"62: Restricted Card\"\n\"62: Invalid card in this country\"\n",
    "errorCode26": "Indicates that the shopper requested to stop a subscription.\nDecline codes such as the following are mapped to this refusal reason:\n\"R1: Revocation of Authorization Order\"\n\"R3: Revocation of All Authorizations Order\"\n\"R0: Stop Payment Order\"\n",
    "errorCode27": "This response maps all those response codes that cannot be reliably mapped. This makes it easier to tell generic declines (for example, Mastercard \"05: Do not honor\" response) from more specific ones.\n",
    "errorCode28": "The withdrawal amount permitted for the shopper's card has exceeded.\n",
    "errorCode29": "The number of withdrawals permitted for the shopper's card has exceeded.\n",
    "errorCode3": "Referrals.\n",
    "errorCode31": "Issuer reported the transaction as suspected fraud.\n",
    "errorCode32": "The address data the shopper entered is incorrect.\n",
    "errorCode33": "The shopper's bank requires the shopper to enter an online PIN.\n",
    "errorCode34": "The shopper's bank requires a checking account to complete the purchase.\n",
    "errorCode35": "The shopper's bank requires a savings account to complete the purchase.\n",
    "errorCode36": "The shopper's bank requires the shopper to enter a mobile PIN.\n",
    "errorCode37": "The shopper abandoned the transaction after they attempted a contactless payment and were prompted to try a different card entry method (PIN or swipe).\n",
    "errorCode38": "The issuer declined the authentication exemption request and requires authentication for the transaction. Retry with 3D Secure.\n",
    "errorCode39": "The issuer or the scheme wasn't able to communicate the outcome via RReq.\n",
    "errorCode4": "The transaction did not go through due to an error that occurred on the acquirer's end.\n",
    "errorCode40": "The payment network can't be reached. Retry the transaction with a different payment method.\n",
    "errorCode41": "A PIN or signature is required. Retry the transaction.\n",
    "errorCode42": "The 3D Secure authentication failed due to an issue at the card network or issuer. Retry the transaction, or retry the transaction with a different payment method.\n",
    "errorCode5": "The card used for the transaction is blocked, therefore unusable.\n",
    "errorCode6": "The card used for the transaction has expired. Therefore it is unusable.\n",
    "errorCode8": "The specified card number is incorrect or invalid.\n",
    "errorCode9": "It is not possible to contact the shopper's bank to authorise the transaction.\n"
  },
  "All Orders": "All Orders",
  "Allow order notifications": "Allow order notifications",
  "Amount": "Amount",
  "An error occurred while updating the password": "An error occurred while updating the password",
  "An error occurred while updating the profile": "An error occurred while updating the profile",
  "Apply": "Apply",
  "Back to cart": "Back to cart",
  "back to home": "back to home",
  "Back to homepage": "Back to homepage",
  "back to payment": "back to payment",
  "Back": "Back",
  "Be notified when we have new stock": "Be notified when we have new stock",
  "Be notified": "Be notified",
  "Become seller": "Become seller",
  "bestseller": {
    "description": "",
    "title": "##Most ## requested"
  },
  "Billing address": "Billing address",
  "Cancel": "Cancel",
  "CANCELLED": "Cancelled",
  "Caractéristiques": "Caractéristiques",
  "Card informations": "Card informations",
  "card Payment": "card Payment",
  "cart": {
    "empty": {
      "message": "",
      "title": "Your cart is empty"
    }
  },
  "Categories": "Categories",
  "category": {
    "label": {
      "bebe": "bebe",
      "electromenager": "electromenager",
      "epicerie": "epicerie",
      "fruits-legumes": "fruitsetlegumes",
      "made-in-mayotte": "madeinmayote",
      "manzaraka": "manzaraka",
      "mode": "mode",
      "quincaillerie": "quincaillerie"
    }
  },
  "Change billing address": "Change billing address",
  "change my billing address": "Change my billing address",
  "Change password your account": "Change password your account",
  "Change password": "Change password",
  "Change your personal informations": "Change your personal informations",
  "Characteristics": "Product details",
  "Check my account": "Check my account",
  "Choose an option": "Choose an option",
  "Choosen shipping method": "Choosen shipping method",
  "City": "City",
  "Clear all": "Clear all",
  "clearCart": "Clear my cart",
  "Close": "Close",
  "Company": "Company",
  "COMPLETED": "Completed",
  "configure": "Discover",
  "Confirm": "Confirm",
  "Connexion": "Connexion",
  "Contact details updated": "Contact details updated",
  "Contact Support": "Contact Support",
  "Contact us": "Contact us",
  "contact us": "contact us",
  "contact": "contact",
  "contactForm": {
    "notifications": {
      "success": "Your message was sent successfully. We will contact you very soon."
    }
  },
  "Continue Shopping": "Continue Shopping",
  "@storefront-ui/styles/styles/_helpers.scss": "Cookie consent",
  "cookie": {
    "googleAnalytic": {
      "description": "Use: These cookies collect statistical data on site traffic in order to optimize its ergonomics, navigation and content.",
      "title": "Google Analytics: measurement of audience and use of the site"
    },
    "googleTag": {
      "description": "Use: These cookies collect statistical data on site traffic in order to optimize its ergonomics, navigation and content.",
      "title": "Google Tag Manager"
    },
    "brevo": {
      "description": "Use: These cookies collect statistical data on site traffic in order to optimize its ergonomics, navigation and content.",
      "title": "Brevo: measurement of audience and use of the site"
    },
    "internalTracker": {
      "description": "Use: These cookies allow the site to function optimally. If you remove them, some site functionalities will be degraded.",
      "title": "Technical cookies necessary for the functioning of the site"
    },
    "learnMore": "Manage cookies",
    "notice": {
      "description": "@SITE_NAME@ uses functional and analytical cookies to make sure our website works properly and to offer you the best possible user experience. By using this website, functional and analytical cookies will be installed on your browser.\nWith your consent, we also use marketing cookies to (i) analyse our marketing performance and to (ii) personalize the offers in our advertisements. By placing these cookies, @SITE_NAME@ and third parties can track your internet behavior to make our content and advertisements more relevant to your interests.\nBy clicking on ‘Accept’, you consent to the placing of all marketing cookies. By clicking on 'Reject', we will not place any marketing cookies. You can change your cookie preferences or withdraw your consent at any given time."
    },
    "noticeModal": {
      "description": "Cookies and other trackers are used for the purposes detailed below for which you can configure your choices.",
      "title": "Cookie management"
    },
    "pageTitle": "cookie consent page",
    "privacy": "To find out more about how cookies work, read our {privacyPolicy}",
    "social": {
      "description": "Use: These cookies make it possible to display information flows or exchanges from social networks on the site.",
      "title": "Social networks"
    }
  },
  "Country": "Country",
  "coupon code already used": "Coupon code already used",
  "coupon code not exist": "Coupon code not exist",
  "coupon": {
    "add": "Coupon code added to cart",
    "allready": "Coupon code already used",
    "not": "Coupon code not exist"
  },
  "couponTotal": "Discount {coupon}",
  "Create account": "Create account",
  "Create an account": "Create an account",
  "Create my account": "Create New account",
  "create new address": "create new address",
  "create new one": "create new one",
  "Current Password": "Current Password",
  "Customer service": "Customer service",
  "customerGroup": {
    "description": "You have signed in with a <b>{customerGroup}</b> account",
    "label": {
      "public": "general public"
    }
  },
  "Date": "Date",
  "Default billing address": "Default billing address",
  "Default shipping address": "Default shipping address",
  "Delete": "Delete",
  "Delivery address": "Delivery address",
  "Delivery options": "Delivery options",
  "Delivery": "Delivery",
  "deliveryTime": {
    "day": " | within  1 day | within  {count} days",
    "hour": " | within  1 hour | within  {count} hours",
    "week": " | within  1 week | within  {count} weeks"
  },
  "Description": "Description",
  "Details and status orders": "Details and status orders",
  "discount": {
    "description": "",
    "title": "Promotions ##and## Flash sell"
  },
  "Discover our categories": "Discover our categories",
  "Discover": "Discover",
  "Documents to download": "Documents to download",
  "Done": "Done",
  "Download all": "Download all",
  "Download": "Download",
  "Echange and return": "Echange and return",
  "Edit my shopping cart": "Edit my shopping cart",
  "Edit": "Edit",
  "Email has been send to your address with Authentication code, verify your email and type received code": "Email has been send to your address with Authentication code, verify your email and type received code",
  "email is required": "email is required",
  "Email": "Email",
  "email": "email",
  "empowerment": {
    "breadcrumb": "CabinPad Authentification",
    "description": "You are about to place an order for the customer below",
    "loading": "Data verification",
    "title": "Welcome to your gift space"
  },
  "ENABLE TWO FACTOR AUTH": "ENABLE TWO FACTOR AUTHENTICATION",
  "Enter promo code": "Enter promo code",
  "Enter your code": "Enter your code",
  "Enter your email address to receive a link to reset your password": "Enter your email address to receive a link to reset your password.",
  "Enter your phone number in case of delivery issue": "Enter your phone number in case of delivery issue",
  "Enter your PNC code": "Enter your PNC code",
  "error": {
    "login": {
      "allreadyExist": "account allready exist",
      "unauthorized": "email or password invalid"
    },
    "server": "Please try again in a few minutes and contact us if the problem persists"
  },
  "errors": {
    "address": {
      "allReadyExist": "Address already exist",
      "notFound": "Address not found",
      "unauthorized": "Not authorized to create address"
    },
    "auth": {
      "count": "Deactivated code, please start a new sign-in process to receive a new code | Last attempt, you will have to authenticate once again | {count} attempts left ",
      "timeOut": "Code has expired",
      "tooMuch": "Too many attempts for this code",
      "unauthorized": "Wrong code"
    },
    "billing": {
      "address": "add a billing address"
    },
    "cartAdresse": {
      "allReadyExist": "address allready exist",
      "notFound": "address not found",
      "unauthorized": "unauthorized address"
    },
    "connexion": "connection refused",
    "login": {
      "allReadyExist": "Account already exists. Please sign in or reset your password instead",
      "notFound": "No account for this email",
      "unauthorized": "Invalid email or password, please check your data"
    },
    "noshipment": "Unable to calculate delivery costs, please try again in a few minutes and contact us if the problem persists ",
    "notFound": "not found",
    "notfound": "not found",
    "server": {
      "access": "Please try again in a few minutes and contact us if the problem persists",
      "relayAddress": "You must have address in France"
    },
    "shipmentMethod": {
      "allReadyExist": "shipment method allready exist",
      "notFound": "shipment method not found",
      "unauthorized": "unauthorized shipment method"
    },
    "unauthorized": "you are not authorized to do this action",
    "not-logged-in": "Your session is expired. Please authenticate yourself again."
  },
  "Exchange / Return": "Exchange / Return",
  "Fast delivery 72h*": "Shipped in 72H*",
  "Feedback": "Feedback",
  "Filters": "Filters",
  "Find a relay point near": "Find a relay point near",
  "First Name": "First Name",
  "First name": "First name",
  "Firstname is requiered": "Firstname is requiered",
  "Firstname is required": "Firstname is required",
  "Flying Blue Program": "Flying Blue Program",
  "Follow us on": "Follow us on",
  "footer": {
    "description": "Proin vel lobortis orci, in volutpat ex. Nam a ante at neque tempor finibus nec nec dui. Praesent mollis auctor lectus quis lobortis. Ut tempus, tellus id vulputate finibus, ante diam ullamcorper magna, eget lacinia dolor lorem ac felis. Duis eleifend auctor consequat. Curabitur placerat lacus in sem congue",
    "menu1": {
      "items": [
        {
          "label": "Devenir vendeur"
        },
        {
          "label": "Guide d'achat"
        },
        {
          "label": "Qui sommes nous ?"
        }
      ],
      "title": "A propos"
    },
    "menu2": {
      "items": [
        {
          "label": "Mes commandes"
        },
        {
          "label": "Nous contacter"
        },
        {
          "label": "Politique de retours"
        }
      ],
      "title": "Service client"
    },
    "menu3": {
      "items": [
        {
          "label": "Conditions générales de vente"
        },
        {
          "label": "Gestion des cookies"
        },
        {
          "label": "Mentions légales"
        },
        {
          "label": "Politique de protection des données personnelles"
        }
      ],
      "title": "Informations"
    },
    "menuAnnexe": {
      "items": []
    },
    "menu": {
      "columns": {
        "social": {
          "title": "Contact",
          "contact": {
            "form": "Contact form",
            "email": "Email: {0}",
            "tel": "Phone: {0}"
          }
        }
      }
    }
  },
  "For more secure access to your account (send a confirmation code by email)": "For more secure access to your account (send a confirmation code by email)",
  "for": "for",
  "Forgot password": "Forgot password",
  "Forgot password?": "Forgot password?",
  "Free delivery": "Free delivery",
  "Free return": "Free return",
  "Free": "Free",
  "free": "free",
  "Friday": "Friday",
  "Further information": "Further information",
  "Get our latest news and best plans": "Get our latest news and best plans",
  "gift wrap": "gift wrap",
  "giftcode": "Card code {coupon}",
  "Go back shopping": "Continue shopping",
  "Go back": "Go back",
  "Go to cart": "View my cart",
  "Go to pass order": "Checkout",
  "Help": "Help",
  "hide": "hide",
  "Home": "Home",
  "I agree to": "I agree to",
  "I crave": "I crave",
  "I discover": "I discover",
  "I have a promotional code": "I have a promotional code",
  "I log in": "Sign in",
  "In practice": "In practice",
  "Info after order": "Info after order",
  "Informations": "Informations",
  "Insufficient stock": "Insufficient stock",
  "invalid email": "invalid email",
  "Item": "Item",
  "items in stock": "items in stock",
  "Items": "Items",
  "Last item in stock": "Last item in stock",
  "Last Name": "Last Name",
  "Last name": "Last name",
  "Lastname is requiered": "\"Lastname is requiered",
  "Lastname is required": "Lastname is required",
  "Legal mentions": "Legal mentions",
  "Less recent": "Less recent",
  "Let’s start now – we’ll help you": "Let’s start now – we’ll help you",
  "Loading": "Loading",
  "loading": "loading",
  "Local products": "Local products",
  "locations": {
    "notFound": "No store found"
  },
  "Log in": "Log in",
  "login in to your account": "login in to your account",
  "Login or Create an account": "Login or Create an account",
  "Login": "Login",
  "loginTitle": "Sign in",
  "Looks like you haven’t added any items to the bag yet": {
    " Start shopping to fill it in": {}
  },
  "Looks like you haven’t added any items to the cart yet": "Looks like you haven’t added any items to the cart yet",
  "Make an order": "Make an order",
  "Manage addresses": "Manage addresses",
  "mangoPay": {
    "01902": "This card is not active",
    "02101": "Internal Error",
    "02624": "Card expired",
    "02625": "Invalid card number",
    "02626": "Invalid date. Use MMYY format",
    "02627": "Invalid CCV number",
    "02628": "Transaction refused",
    "02631": "Delay exceeded",
    "02632": "Method GET is not allowed",
    "09101": "Username/Password is incorrect",
    "09102": "Account is locked or inactive",
    "09104": "Client certificate is disabled",
    "09201": "You do not have permissions to make this API call",
    "cardNumber": {
      "error": "Your card number does not seem to be correct",
      "required": "Card number required"
    },
    "name": {
      "error": "Your name does not seem to be correct",
      "required": "Name required"
    },
    "": ""
  },
  "Menu": "Menu",
  "Message": "Message",
  "Monday": "Monday",
  "More recent": "More recent",
  "More than": "More than",
  "My account": "My account",
  "My Cart": "My Cart",
  "My cart": "My cart",
  "My orders": "Orders",
  "My saved address": "Saved address",
  "My shopping cart": "My shopping cart",
  "myOrders": {
    "order": {
      "backToOrdersList": "Orders list",
      "detailsOrder": {
        "amount": "Amount : ",
        "billingAddress": "Billing address",
        "date": "Date : ",
        "payment": "Payment",
        "paymentMethod": "Payment method : ",
        "reference": "Reference : ",
        "shippingAddress": "Shipping address"
      },
      "eventHistory": {
        "cancelled": {
          "description": "Your order has been cancelled",
          "title": "Cancelled"
        },
        "pending": {
          "description": "Your order is pending process",
          "title": "Pending"
        },
        "completed": {
          "description": "Your order is closed",
          "title": "completed"
        },
        "followPackage": "Parcel #",
        "paymentFailed": {
          "description": "Payment failed",
          "title": "Payment failed"
        },
        "processing": {
          "description": "Payment by credit card",
          "title": "Paid"
        },
        "shipped": {
          "description": "Your order has been shipped",
          "title": "Shipped"
        },
        "partially_shipped": {
          "description": "Your order is partially shipped",
          "title": "Partially shipped"
        }
      },
      "header": {
        "downloadBill": "Download invoice",
        "from": "date :",
        "orderDetails": "Order details {ref}"
      },
      "shippmentOrder": {
        "title": "Follow-up order status"
      },
      "yourOrder": {
        "quantity": "Quantity : {qty}",
        "title": "Your order"
      },
      "parcelsTracking": {
        "title": "Your parcels",
        "usage": "Click on a parcel's reference to see its details"
      }
    }
  },
  "myProfile": {
    "passwordUpdate": {
      "form": {
        "button": "Save password",
        "newPassword": "New password",
        "password": "Password",
        "repeatPassword": "Repeat new password"
      },
      "notifications": {
        "success": "New password are successfuly updated !",
        "error": "All informations aren't successfuly updated ! Please verify your data or contact us if the problem persists"
      },
      "tab": {
        "message": "Your password must contain at least 8 characters, an uppercase letter, a lowercase letter, a number and a symbol (such as : @$!%*?&).",
        "title": "Edit password"
      }
    },
    "profileUpdate": {
      "form": {
        "birthDate": "Birth date",
        "button": "Save changes",
        "email": "Email",
        "firstName": "First name",
        "lastName": "Last name",
        "locale": "Choose language for email notifications",
        "newsLetterSubscribed": "Subscribe newsletter",
        "twoFactorAuthenticationEnabled": "active 2 factor auth"
      },
      "notifications": {
        "success": "All informations are successfuly updated !",
        "error": ""
      },
      "tab": {
        "message": "",
        "title": "Personal data"
      }
    }
  },
  "Need Help": "Need Help",
  "New Password": "New Password",
  "Newsletter": "Newsletter",
  "Next Step": "Next Step",
  "Next step": "Next step",
  "No offer for this product": "No offer for this product",
  "No order yet": "No order recorded",
  "No product for this category": "No product for this category",
  "No products found": "No products found",
  "No result found for term :": "No result found for term :",
  "no result found": "no result found",
  "No saved address": "No saved address",
  "No saved addresses": "No saved addresses",
  "Not a valid Email": "Not a valid Email",
  "not a valid phone number": "not a valid phone number",
  "not a valid post code": "not a valid post code",
  "Not Found": "Not Found",
  "not found": "not found",
  "ok": "ok",
  "OkrAddToCart": {
    "noStock": "Coming soon"
  },
  "Opening times": "Opening times",
  "Order ID": "Order ID",
  "Order N°:": "Order N°:",
  "Order reference": "Order reference",
  "Order Returns": "Order Returns",
  "Order state": "Order state",
  "Order summary": "Order summary",
  "order": {
    "text": "We will begin processing your order shortly. You will soon receive an email receipt to confirm your with your order details."
  },
  "ORDERS": "ORDERS",
  "Our Best Sellers": "Our Best Sellers",
  "Our liked product": "Our liked product",
  "Our references": "Our references",
  "Our universes": "Our universes",
  "Pass order": "Checkout",
  "Pass your order": "Checkout",
  "password forgot": "password forgot",
  "Password must contain eight characters, at least one uppercase letter, one lowercase letter, one number and one special character:": "Password must contain at least eight characters, including one uppercase letter, one lowercase letter, one number and one special character:",
  "Password": "Password",
  "Passwords are different": "Passwords are different",
  "Pay": "Pay",
  "Payment Error": "Payment Error",
  "Payment in pending": "Payment in pending",
  "Payment methods": "Payment methods",
  "Payment received": "Payment received",
  "Payment Return": "Payment Return",
  "Payment": "Payment",
  "payment": {
    "cancelled": "Payment cancelled",
    "error": "Payment error",
    "pending": "Payment in pending",
    "received": "Payment received",
    "refused": "Payment refused",
    "unknown": "Unknown error",
    "errors": {
      "missing-billing-address": "Please choose a billing address."
    }
  },
  "PAYMENT_FAILED": "Payement failed",
  "Personal data": "Personal data",
  "Personalized message only": "Personalized message only",
  "Personalized message option": "Personalized message option",
  "Phone number": "Phone number",
  "Please add a delivery address": "Please add a delivery address",
  "please add address to select shipping and billing address": "please add address to select shipping and billing address",
  "Please choose your country": "Please choose your country",
  "Please contact our customer service :": "Please contact our customer service :",
  "Please enter a valid email address": "Please enter a valid email address",
  "Please enter your email and password": "Please enter your email and password.",
  "Please identify yourself to access your customer account": "Please identify yourself to access your customer account",
  "Please select a delivery address or ": "Please select a delivery address or ",
  "Please select your billing address": "Please select your billing address",
  "Please type minimum 10 characters and maximum 400": "Please type minimum 10 characters and maximum 400",
  "Please type your city": "Please type your city",
  "Please type your last name": "Please type your last name",
  "Please type your name": "Please type your name",
  "Please type your phone number": "Please type your phone number",
  "Please type your street name": "Please type your street name",
  "Please type your zip code": "Please type your zip code",
  "Plus product": "Plus product",
  "PNC code": "PNC code",
  "Previous step": "Previous step",
  "Price": "Price",
  "Primary contacts for any questions": "Primary contacts for any questions",
  "Privacy policy": "Privacy policy",
  "PROCESSING": "Processing",
  "product": {
    "relatedProduct": {
      "errorMessage": "Unable to load related products !",
      "subTitle": "",
      "title": "You may also like"
    }
  },
  "productInCategory": "no product found | 1 product found | {count} products found",
  "productNumber": "...{currentNumber} more of {totalNumber} products",
  "Products found": "Products found",
  "Products": "Products",
  "productStock": "Soon available |last item in stock | {count} items in stock",
  "promotions": "promotions",
  "Purchase guide": "Purchase guide",
  "Q&A": "Q&A",
  "Quantity": "Quantity",
  "Reason for refusal": "Reason for refusal",
  "reason for refusal": "reason for refusal",
  "Receives newsletter": "Receives newsletter",
  "Recevez nos actualités et offres personnalisées": "Recevez nos actualités et offres personnalisées",
  "Recipient": "Recipient",
  "Reference": "Reference",
  "relay": {
    "change": "Change",
    "country": {
      "error": "This delivery service is valid in France only",
      "required": ""
    },
    "notFound": "No relay point found with such address, please check this address is valid",
    "remove": "Remove",
    "select": "Select"
  },
  "remove all filters": "remove all filters",
  "removedProduct": "You have remove</br><span class='product'>{product} to your cart</span>",
  "Repeat Password": "Repeat password",
  "Reset password": "Reset password",
  "Reset your password": "Reset your password",
  "Reset": "Reset",
  "resetpassword": {
    "email": "Si un compte est associé à cette adresse: {email}, vous recevrez un email contenant un lien pour réinitialiser votre mot de passe",
    "error": "An error occurred during your password reset, the link you used is expired. Please get a new one and try again.",
    "valid": "La reinitialisation du mot de passe a bien été prise en compte"
  },
  "Respect of the cold chain": "Respect of the cold chain",
  "rgpd": {
    "pageTitle": "Privacy policy"
  },
  "Same as shipping address": "Same as shipping address",
  "Satisfied or refunded": "Satisfied or refunded",
  "Saturday": "Saturday",
  "Save changes": "Save changes",
  "search term": "Search term",
  "Search": "Search",
  "Secure payment": "Secure payment",
  "select a country": "select a country",
  "Select sorting": "Select sorting",
  "Select": "SELECT",
  "Sell": "Sell",
  "Selled by": "Selled by",
  "sellers": "sellers",
  "Send my feedback": "Send my feedback",
  "seo": {
    "defaultTitle": "Your ecommerce website",
    "defaultDescription": "Easy, fast, and 100% secured !",
    "titlePrefix": "",
    "titleSuffix": " | DEMO"
  },
  "Serveur error, content not found": "Server error, content not found",
  "serviceUnavailable": "An error has occurred. Please try again later.",
  "Set as default billing address": "Set as default billing address",
  "Set as default shipping address": "Set as default shipping address",
  "Set as default": "Set as default",
  "Set my cookies parameters": "Set my cookies parameters",
  "shipment ": "shipment ",
  "shipment": "shipment",
  "SHIPPED": "Shipped",
  "Shipping": "Shipping",
  "Show all result": "Show all result",
  "Show all": "Show all",
  "Show detail": "Show detail",
  "show more": "Show  more",
  "Show my order": "Show my order",
  "Show my shopping cart": "View my shopping cart",
  "Show on page": "Show on page",
  "showCategory": "Show all univers",
  "Sign in": "Sign in",
  "sku": "ref",
  "Sort by": "Sort by",
  "sortBy": "Sort by",
  "Start my shopping": "Start my shopping",
  "Start shopping": "Start my shopping",
  "Start your search": "Start your search",
  "Status": "Status",
  "Street Name": "Street Name",
  "Street name": "Street name",
  "Subject": "Subject",
  "Submit code": "Submit code",
  "Submit": "Submit",
  "SUBSCRIBE NEWSLETTER": "SUBSCRIBE NEWSLETTER",
  "Successful placed order": "Successful placed order",
  "Sunday": "Sunday",
  "Tax amount": "VAT",
  "Tax free total price": "excl. tax subtotal",
  "Tax included price": "incl. tax price",
  "Tax included subtotal price": "incl. tax subtotal",
  "Tax included total price": "Total",
  "Terms and conditions": "Terms and conditions",
  "Terms of sales": "Terms of sales",
  "Terms of use": "Terms of use",
  "Thank you for your order": "thank you for your order",
  "thanksOrder": "Thank you<br/>for your order!",
  "The password has been updated": "The password has been updated",
  "The profile has been updated": "The profile has been updated",
  "These products are out of stock :": "These products are out of stock :",
  "this code is valid 10min": "this code is valid 10min",
  "This products is out of stock :": "This product is out of stock :",
  "Thursday": "Thursday",
  "Too late": "Too late",
  "Total price ": "Total price ",
  "Total shipping price": "Total shipping price",
  "Total": "Total",
  "Transaction reference": "Transaction reference",
  "Tuesday": "Tuesday",
  "twoFactor": {
    "description": "An email has been sent to you with a verification code. Please check your email and type the received code below\n(code is valid 10 min)",
    "title": "Two-factor authentification"
  },
  "type a message": "type a message",
  "Unable to load bestseller": "Unable to load bestseller",
  "Unit price ": "Unit price",
  "Update address": "Update address",
  "Update": "Update",
  "Validate my order": "Validate my order",
  "Validate": "Validate",
  "View details": "View details",
  "Wednesday": "Wednesday",
  "Welcome": "Welcome",
  "welcome": "welcome",
  "WelcomeMessage": "Welcome<br><span class='customer'><span class='firtsname'>{firstName}</span> <span class='lastname'>{lastName}</span></span>",
  "What can we improve": "What can we improve",
  "Where to find us": "Where to find us",
  "Who are we ?": "Who are we ?",
  "Who are we": "Who are we",
  "With gift wrap": "With gift wrap",
  "You are not logged, sign-in or create an account": "You are not logged, sign-in or create an account",
  "You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below": "You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below",
  "You currently have no orders": "You currently have no orders",
  "You have a gift card ?": "You have a gift card ?",
  "You have a promotional code ?": "Got a discount code?",
  "You haven’t searched for items yet": "You haven’t searched for items yet",
  "Your account": "My account",
  "Your cart is empty": "Your cart is empty",
  "Your cart": "My cart",
  "Your coupon code": "Coupon code",
  "your email": "your email",
  "Your name should have at least one character": "Your name should have at least one character",
  "Your order": "Your order",
  "Your password must contain eight characters, at least one uppercase letter, one lowercase letter, one number and one special character": "Password must contain at least eight characters, including one uppercase letter, one lowercase letter, one number and one special character",
  "Your Purchase": "Your Purchase",
  "Your search term : {term}": "Your search term : {term}",
  "Your shipping address": "Your shipping address",
  "Zip-code": "Zip-code",
  "Zipcode should have only numbers": "Zipcode should have only numbers",
  "No product for this seller": "No product for this seller",
  "yes": "yes",
  "no": "no",
  "Shipment total price": "Shipment total price",
  "Category": "Category",
  "form": {
    "account": {
      "forgotPassword": {
        "description": "",
        "title": "",
        "connect": "",
        "submit": ""
      },
      "login": {
        "description": "",
        "title": "",
        "forgot": "",
        "submit": ""
      },
      "signin": {
        "description": "",
        "title": "",
        "newsletterToggle": "",
        "authToggle": "",
        "cgv": {
          "agree": "",
          "toTerms": ""
        }
      },
      "address": {
        "defaultShipping": "",
        "defaultBilling": "",
        "submitNew": "",
        "saveChange": ""
      },
      "passwordChange": {
        "submit": "",
        "notifications": {
          "success": "",
          "error": ""
        }
      },
      "profilUpdate": {
        "locale": "",
        "newsletter": {
          "description": "",
          "title": ""
        },
        "twoFactor": {
          "description": "",
          "title": ""
        },
        "submit": ""
      }
    },
    "errors": {
      "email": "",
      "lastName": "",
      "firstName": "",
      "password": "",
      "repeatPassword": "",
      "street": "",
      "city": "",
      "postCode": "",
      "country": "",
      "phone": "",
      "newPassword": "",
      "birthDate": "",
      "message": ""
    },
    "label": {
      "email": "",
      "password": "",
      "lastName": "",
      "firstName": "",
      "repeatPassword": "",
      "company": "",
      "street": "",
      "city": "",
      "postCode": "",
      "country": "",
      "phone": "",
      "newPassword": "",
      "birthDate": "",
      "orderRef": "",
      "subject": "",
      "message": ""
    },
    "required": {
      "lastName": "",
      "firstName": "",
      "email": "",
      "password": "",
      "repeatPassword": "",
      "street": "",
      "city": "",
      "postCode": "",
      "country": "",
      "phone": "",
      "newPassword": "",
      "birthDate": ""
    },
    "notices": {
      "password": ""
    },
    "placeholder": {
      "country": "",
      "message": ""
    },
    "contact": {
      "title": "",
      "clear": "",
      "submit": "",
      "notifications": {
        "success": ""
      }
    }
  },
  "header": {
    "searchbar": {
      "placeholder": ""
    },
    "seller": {
      "title": ""
    },
    "help": {
      "title": ""
    },
    "account": {
      "connected": {
        "title": ""
      },
      "anonymous": {
        "title": ""
      }
    },
    "menu": {
      "products": "",
      "sellers": "",
      "promotions": "",
      "contact": ""
    }
  },
  "server error": "",
  "TermOf": "",
  "Choose Your Colissimo Relay": "",
  "Stores found": "",
  "Hide": "",
  "name": "",
  "cardNumber": "",
  "Expiration (mm/yy)": "",
  "Security Code": "",
  "loadingRelay": "",
  "pages": {
    "401": {
      "description": "",
      "title": "",
      "cta": {
        "back": ""
      }
    },
    "404": {
      "description": "",
      "cta": {
        "back": ""
      }
    },
    "home": {
      "bloc": {
        "bestseller": {
          "cta": ""
        },
        "categories": {
          "cta": ""
        },
        "marketing": {
          "cta": ""
        },
        "promotion": {
          "cta": ""
        }
      }
    },
    "cms": {
      "error": ""
    },
    "contact": {
      "description": "",
      "title": ""
    },
    "myAccount": {
      "content": {
        "orders": {
          "details": {
            "priceDetails": {
              "priceDetails": {
                "discount": "Discount",
                "shippingMethodHT": "Excl. tax standard shipping",
                "vat": "VAT",
                "dockingFees": "Docking fees",
                "productTotalHT": "Products excl. tax total",
                "productTotalTTC": "Products total",
                "subTotalHT": "Excl. tax subtotal",
                "subTotalTTC": "Subtotal",
                "totalHT": "Excl. tax TOTAL",
                "totalTTC": "TOTAL"
              }
            }
          }
        }
      }
    }
  },
  "loadingLocations": "",
  "products": "",
  "This product is out of stock :": "",
  "components": {
    "okrAddToCart": {
      "quantityLabel": "",
      "noStock": ""
    },
    "orkProductCart": {
      "configure": {
        "fromPrice": "",
        "aria-label": "",
        "label": ""
      }
    },
    "orkStock": {
      "minimalQty": "",
      "productStock": "",
      "stockAlert": {
        "text": "",
        "cta": ""
      }
    }
  },
  "discover": "",
  "password": {
    "error": ""
  },
  "repeatPassword": {
    "error": ""
  },
  "Go to my account": "",
  "searchAutocomplete": {
    "no-result": ""
  },
  "Stay informed": "",
  "page": {
    "bestSeller": {
      "title": ""
    },
    "madeInMayotte": {
      "title": ""
    },
    "promotions": {
      "title": ""
    }
  },
  "No bestseller": "",
  "Our Offers": "",
  "Choose a shipping method": "",
  "breadcrumb": {
    "401": "",
    "404": "",
    "home": "",
    "contact": ""
  },
  "Made In Mayotte": "",
  "PAYMENT FAILED": "",
  "Prestataires": "",
  "description": "",
  "No promotions": "",
  "Promotions": "",
  "shipmentOption": {
    "price": {
      "free": "Free"
    }
  },
  "orderSummary": {
    "title": "Summary",
    "priceLine": {
      "coupon": "Coupon"
    }
  },
  "config": {
    "taxMode": {
      "taxFree": "tax free",
      "taxIncluded": "tax included"
    }
  },
  "psp.systempay.paymentMethod.PAYPAL_BNPL.label": "PayPal - Pay in 4"
}
